const userRequestGenerator = ({
  guid,
  agencyGuid,
  legalname,
  email,
  phone,
  callerId,
  fax,
  addressLine1,
  addressLine2,
  city,
  state,
  zip,
  timezone,
  npiNumber,
  stateIdNumber,
  taxIdNumber,
  taxonomyNumber,
  medicalIdTpiNumber,
  medicareNumber,
  ots,
  otsStartDate,
  autoGeneratedClaimDrop,
  clinicId,
  crmId,
  onCallAfterHoursNumber,
  instructions,
  notes,
  dateNoteLogged,
  officeHours,
  threshold,
  status,
  clientSuccessOnboardingGuid,
  clientSuccessScalingGuid,
  salesRepresentativeGuid,
  parentClinicGuid,
  finId,
  acceptPvrLite,
}) => {
  const body = {
    guid,
    agencyGuid,
    legalname,
    email,
    phone,
    callerId,
    fax,
    addressLine1,
    addressLine2,
    city,
    state,
    zip,
    timezone,
    npiNumber,
    stateIdNumber,
    taxIdNumber,
    taxonomyNumber,
    medicalIdTpiNumber,
    medicareNumber,
    ots,
    otsStartDate: otsStartDate === '' ? 'none' : otsStartDate,
    autoGeneratedClaimDrop,
    clinicId,
    crmId,
    onCallAfterHoursNumber,
    instructions,
    notes,
    dateNoteLogged,
    officeHours,
    threshold,
    status,
    clientSuccessOnboarding: clientSuccessOnboardingGuid,
    clientSuccessScaling: clientSuccessScalingGuid,
    salesRepresentative: salesRepresentativeGuid,
    parentClinicGuid,
    finId,
    acceptPvrLite,
  };
  return body;
};
export default userRequestGenerator;
